import { Scope } from './interface'

export default function a8solo(scope: Scope) {
    return `
        interface GenerateSeqIdSoloRequest {
            tag?: string
        }
        
        interface GenerateSeqIdSoloResponse {
            sequenceId: string
        }

        interface SessionInfo {
            id: string,
            isLive: boolean,
            flowName: string,
            flowType: "public" | "private",
            currentNode: CurrentNode,
            customer: Customer | null,
            isAssignedToAgent: boolean,
            timeline: Timeline[],
            createdAt: string,
            updatedAt: string | null
        }

        interface CurrentNode {
            id: string,
            name: string,
            type: string
        }

        interface Customer {
            loginId: string,
            name: string | null,
            email: string | null,
            mobile: string | null,
            data: object | null,
            lastLogin: string | null,
            createdAt: string
        }

        interface Timeline {
            nodeName: string,
            createdAt: string,
            status: string
        }

        interface SMTPDetails {
            host: string
            port: number
            ssl: boolean
            senderEmail: string
            senderEmailPassword: string
            username?: string
        }
        interface AttachmentValue {
            fileName: string
            value: string
        }

        interface RecurrenceRules {
            repeatFrequency: string,
            repeatOnMonthDays?: number [],
            repeatOnWeekDays?: string [],
            repeatInterval?: number,
            repeatInMonths?: number [],
            repeatUntil?: string,
            repeatCount?: number
        }

        interface CalendarEvent {
            eventStart: string,
            eventEnd: string,
            timeZone: string,
            title: string,
            description?: string,
	        location?: string,
	        organizerName?: string,
	        organizerEmail?: string,
            recurrenceRules?: RecurrenceRules,
        }

        interface SendMailRequest {
            to: string[]
            cc?: string[]
            subject: string
            body: string
            attachments?: {
                urlList?: AttachmentValue[]
                base64List?: AttachmentValue[]
            }
            smtpDetails?: SMTPDetails
            calendarEvent?: CalendarEvent
        }
        
        interface SignedURLRequest {
            expTimeInMinutes?: number;
            urlList: {
                [name: string]: string;
            };
        }

         interface NoOfAvailableAgentReq {
            groupIds?: string[],
            groupId?: string,
            status?: string
        }
        
         interface NoOfAvailableAgentRes {
            count: number
            agents: AgentInfo[]
        }
         interface AgentInfo {
            name: string
            state: string
            groupIds: string[]
        }
         interface AvgQueueWaitTimeReq {
            groupId: string,
            time: number
        }
        
         interface AvgQueueWaitTimeRes {
            avgWaitTime: number
            totalChats: number
        }
        
         interface NLPServiceRes {
            query: string
            topScoringIntent: TopScoringIntent
            intents: Intent[]
            entities: Entity[]
        }
        
         interface TopScoringIntent {
            intent: string
            score: number
        }
         interface Intent {
            intent: string
            score: number
        }
        
         interface Entity {
            entity: string
            type: string
            startIndex: number
            endIndex: number
            resolution: Resolution
        }
        
         interface Resolution {
            values: string[]
        }
        
         interface BusinessHoursStatusRes {
            isOpen: boolean
        }
        
         interface ChatTranscript {
            from: string
            message: string
        }

        interface ChatContentStyle {
            orientation: string
        }
        interface ChatContentChoice {
            id: string
            label: string
            description?: string
        }
        interface ChatContentCard {
            id: string
            url: string
            title: string
            subtitle: string
            description: string
            actions?: ChatContentActions
        }

        interface ChatContentActions {
            primary?: ChatContentAction
            secondary?: ChatContentAction
        }
        interface ChatContentAction {
            label: string
            type: string
            value?: string
        }
        interface ChatContentResp {
            type: string
            payload: any
            ${(scope === 'functionServer' || scope === 'service') && `send: any`}
        }
        
        interface RequestVariable {
            name: string
            value: string
        }
        interface DuplicateSessionRequest {
            variables: RequestVariable[]
            outVariables?: string[]
            since?:string
        }

        declare var a8solo: {
            generateSequenceId(request?: GenerateSeqIdSoloRequest): Promise<GenerateSeqIdSoloResponse>;
            getSessionInfo(): Promise<SessionInfo>;
            sendMail(request: SendMailRequest): Promise<any>;
            assignToUser(): Promise<any>;
            getSignedURL(request: SignedURLRequest): Promise<{ [key: string]: string }>
            nlpService(request: string): Promise<NLPServiceRes>
            noOfAvailableAgent(request: NoOfAvailableAgentReq): Promise<NoOfAvailableAgentRes>
            avgQueueWaitTime(request: AvgQueueWaitTimeReq): Promise<AvgQueueWaitTimeRes>
            businessHoursStatus(): Promise<BusinessHoursStatusRes>
            getChatTranscript():Promise<ChatTranscript[]>
            message: {
                    newText(text: string): Promise<ChatContentResp>
                    newSimpleChoice(title: string, style: ChatContentStyle, choices: ChatContentChoice[]): Promise<ChatContentResp>
                    newCardChoice(title: string, style: ChatContentStyle, choices: ChatContentChoice[]): Promise<ChatContentResp>
                    newPdf(url: string, fileName: string, description: string): Promise<ChatContentResp>
                    newImage(url: string, fileName: string, description: string): Promise<ChatContentResp>
                    newAutoComplete(title: string, options: ChatContentChoice[], isMulti: boolean, isClearable: boolean,isCreatable: boolean): Promise<ChatContentResp>
                    newCardCarousel(title: string, cards: ChatContentCard[]): Promise<ChatContentResp>
                    newAdaptiveCard(title: string, payload: object): Promise<ChatContentResp>
                    newMarkdown(markdownText: string): Promise<ChatContentResp>
                }
            getChatVariables(): Promise<any>
            setChatVariables(request: { [key: string]: any }): Promise<any>
            deleteChatVariables(request: string | string[]): Promise<any>
            getUserVariables(): Promise<any>
            setUserVariables(request: { [key: string]: any }): Promise<any>
            deleteUserVariables(request: string | string[]): Promise<any>
             ${(scope === 'functionServer' || scope==="service" ) && 'dedupe(request: DuplicateSessionRequest) => Promise<DuplicateSessionRequest>;'}
        }
    `
}
